var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--fluid fill-height"},[_c('v-row',{attrs:{"no-gutters":"","dense":"","align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_vm._t("page")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }